// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7147":"09137fd2","8185":"09137fd2"}[chunkId] + ".chunk.css";
};